import { Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { ErrorBoundary } from "./components/common/ErrorBoundary";
import { MainLayout } from "./components/layout/MainLayout";
import { Dashboard } from "./features/dashboard";
import { Settings } from "./features/settings";

function App() {
  return (
    <ErrorBoundary>
      <MainLayout>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </MainLayout>
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 4000,
        }}
      />
    </ErrorBoundary>
  );
}

export default App;
